<style lang="less">
</style>

<template>
  <el-card>
    <div slot="header"></div>
    <div class="form-container">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="135px"
        v-loading="loading"
      >
        <el-form-item label="系列名称" prop="title">
          <el-input v-model="form.title" placeholder="系列名称" />
        </el-form-item>
        <el-form-item label="产品分类" prop="product_cate_id">
          <el-select v-model="form.product_cate_id" placeholder="请选择">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in cates" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input type="number" v-model="form.weight" placeholder="" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      id: null,
      cates: [],
      loading: false,
      form: {
        title: "",
        weight: ''
      },
      rules: {
        title: this.$formHelper.requiredRuleFactory("请填写系列名称"),
        weight: this.$formHelper.requiredRuleFactory("请填写权重"),
          product_cate_id: [{ required: true, message: '请选择产品分类', trigger: 'blur' }],
      },
      iconrlList: [],
    };
  },

  methods: {
    async init() {
      const { id } = this.$route.query;

        const queryParam = {
          query: {},
          pagination: { limit: 20 },
        };
        const { collection } = await this.$store.dispatch(
          "productCates/collection",
          queryParam
        );
        this.cates = collection;

      if (id) {
        this.id = id;
        const { document } = await this.$store.dispatch("series/document", id);
        this.form = _.cloneDeep(document);
      }
    },

    async onSubmit() {
      try {
        await new Promise((resovle, reject) => {
          this.$refs["ruleForm"].validate((valid) => {
            valid ? resovle(true) : reject(false);
          });
        });
      } catch (e) {
        return false;
      }

      try {
        let form = {
          title: this.form.title,
          weight: this.form.weight,
          product_cate_id: this.form.product_cate_id
        };
        this.loading = true;
        if (this.id) {
            form.id = this.id
          await this.$store.dispatch("series/update", form);
          this.$message.success("编辑成功");
        } else {
          await this.$store.dispatch("series/create", form);
          this.$message.success("添加成功");
        }
        this.loading = false;
        this.$router.push("/product/series-list");
      } catch (error) {
        this.$message.error(error.response.data.message);
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>